import styled, { css } from 'styled-components';
import { Box } from '@helloworld1812/ws-components';

const PageLayout = styled(Box)(() => {
  return css`
    width: 100%;
    box-sizing: border-box;

    > :nth-child(2) {
      padding: 0;
    }
  `;
});

export const S = {
  PageLayout,
};
